import Repository from '@/repositories/marketing'
const resource = '/analytics/reports'

export default {
  fetchReports(config) {
    return Repository.get(`${resource}/campaigns.json`, config)
  },
  fetchWebsites(config) {
    return Repository.get(`${resource}/websites.json`, config)
  },
  fetchJourneys(config) {
    return Repository.get(`${resource}/workflows.json`, config)
  },
  getIspDetails(config) {
    return Repository.get(`${resource}/campaign_isp.json`, config)
  },
}